<template>
    <div class="row h-100 justify-content-center align-items-center bg-danger text-light">
        <div class="col-11 col-sm-8">
            <h3>Instrucciones</h3>
            <p class="text-justify">{{ getEvaluation.instructions }}</p>
            <button class="btn btn-light btn-lg mt-4" @click="start">Comenzar</button>
        </div>
    </div>
</template>

<script>
import router from "../router";
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters(["getEvaluation"]),
    },
    methods: {
        start() {
            router.push({ name: "Questions", params: { number: 0 } });
        },
    },
};
</script>

<style>
</style>
